import { keywords } from './impl';

export const MODIFIER_KEYWORDS = keywords('Modifier');
